import Vue from 'vue'
import App from './App.vue'
import VueLazyload from 'vue-lazyload'

Vue.config.productionTip = false

Vue.use(VueLazyload, {
  loading: `${require('./assets/img/przedruk_loader2.gif')}`
})

// Bus Event init
export const bus = new Vue();

new Vue({
  render: h => h(App),
}).$mount('#app')

